<div class="report-card">
    <!-- Actions sit ABOVE the table: the assistant's follow-up prose refers
         to "the download buttons in the report card above", and a long report
         pushes them off-screen if they trail the table. -->
    <div class="report-card-actions">
        <a *ngIf="csvUrl"
           mat-flat-button
           color="primary"
           class="report-card-download-button"
           [disableRipple]="true"
           [href]="csvUrl"
           target="_blank" rel="noopener noreferrer">
            Export CSV
        </a>
        <a *ngIf="pdfUrl"
           mat-flat-button
           color="primary"
           class="report-card-download-button"
           [disableRipple]="true"
           [href]="pdfUrl"
           target="_blank" rel="noopener noreferrer">
            Save as PDF
        </a>
        <a *ngIf="reportsPageUrl"
           mat-button
           linkButton
           [disableRipple]="true"
           [routerLink]="reportsPageUrl">
            Open in Reports
        </a>
    </div>

    <app-report-table
        [columns]="columns"
        [rows]="rows"
        [orgName]="orgName"
        [reportTitle]="reportName"
        [dateSubtitle]="dateRange">
    </app-report-table>
</div>
